/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Vocabulary_SubInputs */



/**
* | output |
* | --- |
* | "Use KNP Guides for AI Transcription" |
*
* @param {Custom_Vocabulary_SubInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_vocabulary_sub = /** @type {((inputs?: Custom_Vocabulary_SubInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Vocabulary_SubInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez les guides KNP pour la transcription IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzen Sie KNP-Leitfäden für die KI-Transkription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizzare le guide KNP per la trascrizione AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используйте руководства KNP для транскрипции с помощью ИИ.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utilice las guías KNP para la transcripción de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用 KNP 指南进行 AI 转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIトランスクリプションにKNPガイドを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई ट्रांसक्रिप्शन के लिए केएनपी गाइड का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Use os Guias KNP para Transcrição por IA")
	return /** @type {LocalizedString} */ ("Use KNP Guides for AI Transcription")
});